import { render, staticRenderFns } from "./winnerList.vue?vue&type=template&id=5c378376&scoped=true&"
import script from "./winnerList.vue?vue&type=script&lang=js&"
export * from "./winnerList.vue?vue&type=script&lang=js&"
import style0 from "./winnerList.vue?vue&type=style&index=0&id=5c378376&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c378376",
  null
  
)

export default component.exports